import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=462607c1&scoped=true"
import script from "./agreement.vue?vue&type=script&lang=js"
export * from "./agreement.vue?vue&type=script&lang=js"
import style0 from "./agreement.vue?vue&type=style&index=0&id=462607c1&prod&lang=css"
import style1 from "./agreement.vue?vue&type=style&index=1&id=462607c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462607c1",
  null
  
)

export default component.exports